import { api } from "./client";

export type NotificationCategory =
  | "agentErrors"
  | "approvals"
  | "issueUpdates"
  | "systemAlerts";

/** Only email has a real delivery backend (SES); there is no push channel. */
export type NotificationPrefs = Record<NotificationCategory, { email: boolean }>;

export const notificationPrefsApi = {
  get: (companyId: string) =>
    api.get<{ prefs: NotificationPrefs }>(
      `/companies/${companyId}/notification-prefs`,
    ),
  update: (companyId: string, prefs: Partial<NotificationPrefs>) =>
    api.put<{ prefs: NotificationPrefs }>(
      `/companies/${companyId}/notification-prefs`,
      prefs,
    ),
};
